import qs from 'qs'
import { request } from '@/api/axios'
import { getAccessToken } from '@/utils/auth'

// 获取 token
// 数据类型必须为 form-data 格式
export function getOauthTokenApi(data) {
  return request({
    method: 'post',
    url: '/oauth/token',
    data: qs.stringify(data),
    skipDuplicateCheck: true,
  })
  // return post('/oauth/token', qs.stringify(data))
}

// 检查 token 有效性，获取企业信息
export function checkOauthTokenApi() {
  return request({
    method: 'post',
    url: '/oauth/check_token',
    params: {
      token: getAccessToken(),
    },
  })
}

/**
 * 获取手机验证码
 * @param {string} phoneNumber - 手机号码
 * @param {string} type - 验证码类别
 * @returns
 */
export function getSmsCodeApi(data) {
  return request({
    method: 'post',
    url: '/notify/captcha/sendSmsCaptcha',
    data,
  })
}

/**
 * 校验手机验证码
 * @returns
 *
 */
export function validateSmsCodeApi(params) {
  return request({
    method: 'post',
    url: '/notify/captcha/verifySmsCaptcha',
    data: {
      ...params,
      serviceType: SERVICE_TYPE,
    },
  })
}

/**
 * 获取图形验证码
 * @returns
 */
export function getCaptchaApi() {
  return request({
    method: 'get',
    url: '/notify/captcha/getPictureCaptcha',
  })
}

/**
 * 验证图形验证码
 * @param {string} code - 验证码
 * @returns
 */
export function validateCaptchaApi(code: string) {
  return request({
    method: 'post',
    url: '/notify/captcha',
    params: {
      captcha: code,
    },
  })
}

/**
 * 获取当前用户企业信息
 * @returns
 */
export function getCompanyListApi() {
  return request({
    url: '/oauth/user/getCurrentUser',
  })
}

/**
 * 获取服务条款
 * @returns
 */
export function getPrivacyFileUrlApi() {
  return request({
    method: 'get',
    url: '/base/address/url',
  })
}

/**
 * 查看商户号
 * @returns
 */
export function getBusiness(params: { companyId: string }): Promise<{ merchantId: string }> {
  return request<{ merchantId: string }>({
    method: 'get',
    url: '/admin/web/clientManagement/enterpriseRightManagement/getMerchantId',
    params,
  })
}

/**
 * 添加商户号
 * @returns
 */
export function postBusiness(data: {
  companyId: string,
  merchantId: string,
}) {
  return request<null>({
    method: 'post',
    url: '/admin/web/clientManagement/enterpriseRightManagement/addMerchantId',
    data,
  })
}

/**
 * 验证企业是否停用
 * @param {string|number} companyId -  企业ID
 * @returns
 */
export function validateCompanyStatus(companyId: string) {
  return request({
    method: 'get',
    url: `/admin/company/status/${companyId}`,
  })
}

export function logoutApi() {
  return request({
    method: 'get',
    url: '/auth/logout',
  })
}
